<!-- eslint-disable vue/no-unused-properties -->
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
import { BaseInputField, InputType } from '@/interfaces/InputFields';

const model = defineModel();

const props = defineProps<
  BaseInputField & {
    autofocus?: boolean;
    disabled?: boolean;
    valid: boolean;
    centered?: boolean;
    seekResume?: File;
  }
>();

const emit = defineEmits(['image-loaded', 'files-changed', 'seek-resume-cleared']);

const fileName = ref('No file chosen');
const fileInput = ref();
const imageUpload = props.type === InputType.File && props.mime === 'image/*';

const handleChange = ($event: Event) => {
  const target = $event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    fileName.value = target.files[0].name;
    if (imageUpload) {
      const reader = new FileReader();
      reader.readAsDataURL(target.files[0]);
      reader.onload = () => {
        emit('image-loaded', reader.result?.toString());
      };
    }
    emit('files-changed', target.files[0]);
    // eslint-disable-next-line
    model.value = target.files[0];
  } else if (imageUpload) {
    emit('image-loaded', '');
  }

  if (!target.files) {
    // eslint-disable-next-line
    model.value = '';
  }
};

const resetField = () => {
  model.value = '';
  fileInput.value.value = '';
  fileName.value = 'No file chosen';
  if (imageUpload) {
    emit('image-loaded', '');
  }
  const event = new Event('change');
  fileInput.value.dispatchEvent(event);
};

onMounted(() => {
  if (props.seekResume) {
    handleChange({
      target: {
        // @ts-expect-error
        files: [props.seekResume],
      },
    });
  }
});
</script>

<template>
  <label
    :id="name"
    class="Field Field--file z-50"
    :class="{
      'Field--invalid': !valid,
    }"
  >
    <span class="Field--file__label flex items-center justify-center"
      >{{ fileName }}
      <div v-if="fileName !== 'No file chosen'" class="cursor-pointer" @click.prevent="resetField()">
        <connx-icon name="fas fa-times" class="ml-2 text-notifications-error"></connx-icon>
      </div>
    </span>
    <span class="Field--file__button"> Choose File </span>
    <input
      ref="fileInput"
      class="absolute opacity-0 w-0 h-0"
      type="file"
      :accept="mime"
      :name="name"
      @change="handleChange($event as Event)"
      @blur="handleChange($event as Event)"
    />
  </label>
</template>
